interface SparklineProps {
  values: number[];
  height?: number;
  ariaLabel: string;
}

export function Sparkline({ values, height = 28, ariaLabel }: SparklineProps) {
  const max = Math.max(...values, 1);
  const barCount = values.length;
  return (
    <svg
      role="img"
      aria-label={ariaLabel}
      viewBox={`0 0 ${String(barCount * 10)} ${String(height)}`}
      width={barCount * 10}
      height={height}
      style={{ display: 'block' }}
    >
      {values.map((v, i) => {
        const barHeight = Math.max(2, (v / max) * (height - 2));
        const x = i * 10 + 1;
        const y = height - barHeight;
        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={8}
            height={barHeight}
            rx={1.5}
            fill={v > 0 ? 'var(--ink)' : 'var(--line)'}
          />
        );
      })}
    </svg>
  );
}
